<template>
  <div class="py-4 container-fluid">
    <div class="row"></div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>
